/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CaptureLabelSchema } from './CaptureLabelSchema';
import {
    CaptureLabelSchemaFromJSON,
    CaptureLabelSchemaFromJSONTyped,
    CaptureLabelSchemaToJSON,
    CaptureLabelSchemaToJSONTyped,
} from './CaptureLabelSchema';

/**
 * 
 * @export
 * @interface UpdateCaptureLabelResponse
 */
export interface UpdateCaptureLabelResponse {
    /**
     * 
     */
    label: CaptureLabelSchema;
}

/**
 * Check if a given object implements the UpdateCaptureLabelResponse interface.
 */
export function instanceOfUpdateCaptureLabelResponse(value: object): value is UpdateCaptureLabelResponse {
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function UpdateCaptureLabelResponseFromJSON(json: any): UpdateCaptureLabelResponse {
    return UpdateCaptureLabelResponseFromJSONTyped(json, false);
}

export function UpdateCaptureLabelResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCaptureLabelResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'label': CaptureLabelSchemaFromJSON(json['label']),
    };
}

export function UpdateCaptureLabelResponseToJSON(json: any): UpdateCaptureLabelResponse {
    return UpdateCaptureLabelResponseToJSONTyped(json, false);
}

export function UpdateCaptureLabelResponseToJSONTyped(value?: UpdateCaptureLabelResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': CaptureLabelSchemaToJSON(value['label']),
    };
}

